import script from "./StoreContextCheckoutTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoreContextCheckoutTile.vue?vue&type=script&lang=ts&setup=true"

import "./StoreContextCheckoutTile.vue?vue&type=style&index=0&id=2c3952f4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3952f4"]])

export default __exports__